<template>
  <div class="section">
    <NewsEditor :news="theNews(newsId)" @submitted="updateNews" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import NewsEditor from '@/components/editNews/NewsEditor.vue';

export default {
  name: 'ViewNews',
  components: {
    NewsEditor,
  },
  props: ['newsId'],
  computed: {
    ...mapGetters({
      theNews: 'news/dataById',
    }),
  },
  methods: {
    updateNews(payload) {
      this.$store.dispatch('news/UPDATE', payload);
    },
  },
};
</script>

<style>
</style>
